export const is1dArrayEqual = (a: any[], b: any[]) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; ++i) {
    let flag = false;
    for (let j = 0; j < b.length; ++j) {
      if (a[i] === b[j]) {
        flag = true;
        break;
      }
    }
    if (!flag) return false;
  }
  return true;
};
